var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-img',{key:_vm.src,staticClass:"white",attrs:{"min-height":"100vh","height":_vm.$vuetify.breakpoint.mdAndUp ? '100vh' : undefined}},[_c('div',{staticClass:"d-block d-md-flex",class:[_vm.$vuetify.breakpoint.mdAndUp && 'fill-height']},[_c('page-app-bar'),_c('router-view'),_c('page-footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }